import {AILinktype} from "../../types/linktype";

export const aiinigem: AILinktype[] = [
    {
        title: "Discussion Software & AI in Biology",
        link: "https://static.igem.wiki/teams/5346/hp/ideation-hp.pdf",
        tag: "presentation",
        author: "IISc-Software 2024",
        textinfo: {
            focus: "",
            aiin: [],
            aidifferentiation: undefined,
        },
        pages: undefined,
        search: 1,
        documenttype: undefined,
        definitions: [],
        sourceinfo: undefined,
    },
    {
        title: "AI Safety Policies (Guideline)",
        link: "https://static.igem.wiki/teams/5461/ai-safety-guideline.pdf",
        tag: "guideline",
        author: "LCG-China 2024",
        textinfo: {
            focus: "ai",
            aiin: [],
            aidifferentiation: false,
        },
        pages: 3,
        search: 1,
        documenttype: undefined,
        definitions: [],
        sourceinfo: {
            exist: false
        },
        notes: [
            "Does not even use the word 'artificial intelligence' anywhere in the text, just the abbreviation 'AI'",
            "No real reasoning for recommendations",
            "No explanations on how to reach the goals (e.g. 'importance of tracing data provenance')",
            "No ways mentioned how the restrictions should be enforced",
            "'Ethical Standards' mention only searches (whatever that means) and do not seem to focus on generated" +
            " content in general",
            "AI chat record section in wiki good idea but impractical"
        ]
    },
    {
        title: "AI in Synthetic Biology and iGEM",
        link: "https://static.igem.wiki/teams/5567/education/files/ai-in-synbio-and-igem.pdf",
        tag: "presentation",
        author: "LU-CP 2025",
        textinfo: {
            focus: "",
            aiin: [],
            aidifferentiation: undefined,
        },
        pages: undefined, search: 1, documenttype: undefined,
        definitions: [],
        sourceinfo: undefined,
    },
    {
        title: "A brief inquiry into de novo protein design",
        link: "https://static.igem.wiki/teams/5172/pdf/ai-redesign-cycle.pdf",
        tag: "tool",
        author: "Sheffield 2024",
        textinfo: {
            focus: "",
            aiin: [],
            aidifferentiation: undefined,
        },
        pages: undefined, search: 1, documenttype: undefined,
        definitions: [],
        sourceinfo: undefined,
    },
    {
        title: "Plasmid.AI Accelerating Antibiotic Resistance Therapy Using AI",
        link: "https://static.igem.wiki/teams/5230/entrepreneurship/appendix-part1-plasmidai.pdf",
        tag: "presentation",
        author: "UToronto 2024",
        textinfo: {
            focus: "",
            aiin: [],
            aidifferentiation: undefined,
        },
        pages: undefined, search: 1, documenttype: undefined,
        definitions: [],
        sourceinfo: undefined,
    },
    {
        title: "Investigation and Reflections on Policies for Artificial Intelligence Uses in Synthetic Biology",
        link: "https://static.igem.wiki/teams/4826/wiki/investigation-and-reflections-on-policies-for-artificialintelligence-uses-in-synthetic-biology.pdf",
        tag: "guideline",
        author: "SYSU-Software 2023",
        textinfo: {
            focus: "ai",
            aiin: [],
            aidifferentiation: false,
        },
        pages: 6,
        search: 1,
        documenttype: undefined,
        definitions: [],
        sourceinfo: {
            exist: true,
            sources: []
        },
    },
    {
        title: "Protein × AI The latest technology in synthetic biology",
        link: "https://static.igem.wiki/teams/5680/patch12/80.pdf",
        tag: "presentation",
        author: "TSUKUBA 2025",
        textinfo: {
            focus: "",
            aiin: [],
            aidifferentiation: undefined,
        },
        pages: undefined, search: 1, documenttype: undefined,
        definitions: [],
        sourceinfo: undefined,
    },
    {
        title: "Multi-Faceted Governance of AI in Bio",
        link: "https://static.igem.wiki/teams/4943/wiki/safety/wet-lab-background/safety/multi-faceted-ai-governance-bio-final-2023-docx-4-4-1.pdf",
        tag: "governance",
        author: "",
        textinfo: {
            focus: "",
            aiin: [],
            aidifferentiation: undefined,
        },
        pages: undefined, search: 1, documenttype: undefined,
        definitions: [],
        sourceinfo: undefined,
    },
    {
        title: "INCLUSIVITY-COURSE IV - Introduction to Artificial Intelligence",
        link: "https://static.igem.wiki/teams/5115/inclusivity/course-materials/course-4-lesson-plan-en.pdf",
        tag: "education",
        author: "Fudan 2024",
        textinfo: {
            focus: "",
            aiin: [],
            aidifferentiation: undefined,
        },
        pages: undefined, search: 1, documenttype: undefined,
        definitions: [],
        sourceinfo: undefined,
    },
    {
        title: "AImersion AImersion AI in Synthetic Biology: Through People's Eyes",
        link: "https://static.igem.wiki/teams/5230/human-practices/aimersion.pdf",
        tag: "presentation",
        author: "UToronto 2024",
        textinfo: {
            focus: "",
            aiin: [],
            aidifferentiation: undefined,
        },
        pages: undefined, search: 1, documenttype: undefined,
        definitions: [],
        sourceinfo: undefined,
    },
    {
        title: "Biology safety with artificial intelligence",
        link: "https://static.igem.wiki/teams/5354/collaboration/bioai1.pdf",
        tag: "guideline",
        author: "various iGEM teams 2024",
        textinfo: {
            focus: "",
            aiin: [],
            aidifferentiation: undefined,
        },
        pages: undefined, search: 1, documenttype: undefined,
        definitions: [],
        sourceinfo: undefined,
    },
    {
        title: "BiomniGEM: A paradigm shift in biological AI through multimodal understanding",
        link: "https://static.igem.wiki/teams/6032/file/biomnigem.pdf",
        tag: "application",
        author: "Jilin-AI 2025",
        textinfo: {
            focus: "",
            aiin: [],
            aidifferentiation: undefined,
        },
        pages: undefined, search: 1, documenttype: undefined,
        definitions: [],
        sourceinfo: undefined,
    },
    {
        title: "Plasmid.AI business plan",
        link: "https://static.igem.wiki/teams/5230/entrepreneurship/plasmidaibusinessplan.pdf",
        tag: "business",
        author: "UToronto 2024",
        textinfo: {
            focus: "",
            aiin: [],
            aidifferentiation: undefined,
        },
        pages: undefined, search: 1, documenttype: undefined,
        definitions: [],
        sourceinfo: undefined,
    },
    {
        title: "AME (opinions on AI)",
        link: "https://static.igem.wiki/teams/5230/entrepreneurship/appendix-part2-plasmidai.pdf",
        tag: "",
        author: "",
        textinfo: {
            focus: "",
            aiin: [],
            aidifferentiation: undefined,
        },
        pages: undefined, search: 1, documenttype: undefined,
        definitions: [],
        sourceinfo: undefined,
    },
    {
        title: "",
        link: "https://static.igem.wiki/teams/5708/humanpracticesimg/mystiphage-bp-final.pdf",
        tag: "business",
        author: "",
        textinfo: {
            focus: "",
            aiin: [],
            aidifferentiation: undefined,
        },
        pages: undefined, search: 1, documenttype: undefined,
        definitions: [],
        sourceinfo: undefined,
    },
    {
        title: "Handbook of Activity Design Volume V",
        link: "https://static.igem.wiki/teams/5567/education/files/volume-5-university-student.pdf",
        tag: "",
        author: "",
        textinfo: {
            focus: "",
            aiin: [],
            aidifferentiation: undefined,
        },
        pages: undefined, search: 1, documenttype: undefined,
        definitions: [],
        sourceinfo: undefined,
    },
    {
        title: "",
        link: "https://static.igem.wiki/teams/5928/entrepreneurship/pitch-deck.pdf",
        tag: "",
        author: "",
        textinfo: {
            focus: "",
            aiin: [],
            aidifferentiation: undefined,
        },
        pages: undefined, search: 1, documenttype: undefined,
        definitions: [],
        sourceinfo: undefined,
    },
    {
        title: "",
        link: "https://static.igem.wiki/teams/5034/achievement-4.pdf",
        tag: "",
        author: "",
        textinfo: {
            focus: "",
            aiin: [],
            aidifferentiation: undefined,
        },
        pages: undefined, search: 1, documenttype: undefined,
        definitions: [],
        sourceinfo: undefined,
    },
    {
        title: "",
        link: "https://static.igem.wiki/teams/5916/education/public/perspective-analysis.pdf",
        tag: "",
        author: "",
        textinfo: {
            focus: "",
            aiin: [],
            aidifferentiation: undefined,
        },
        pages: undefined, search: 1, documenttype: undefined,
        definitions: [],
        sourceinfo: undefined,
    },
    {
        title: "",
        link: "https://static.igem.wiki/teams/5754/entrepreneurship/bp.pdf",
        tag: "",
        author: "",
        textinfo: {
            focus: "",
            aiin: [],
            aidifferentiation: undefined,
        },
        pages: undefined, search: 1, documenttype: undefined,
        definitions: [],
        sourceinfo: undefined,
    },
    {
        title: "",
        link: "https://static.igem.wiki/teams/5230/entrepreneurship/6minutepitchplasmidai.pdf",
        tag: "",
        author: "",
        textinfo: {
            focus: "",
            aiin: [],
            aidifferentiation: undefined,
        },
        pages: undefined,
        search: 1,
        documenttype: undefined,
        definitions: [],
        sourceinfo: undefined,
    },
    {
        title: "",
        link: "https://static.igem.wiki/teams/5183/hub/designpage/design.pdf",
        tag: "",
        author: "",
        textinfo: {
            focus: "",
            aiin: [],
            aidifferentiation: undefined,
        },
        pages: 3,
        search: 2,
        documenttype: undefined,
        definitions: [],
        sourceinfo: undefined,
    },
    {
        title: "Synthetic Biology AI Experience Day",
        link: "https://static.igem.wiki/teams/5567/education/files/aiday.pdf",
        tag: "",
        author: "",
        textinfo: {
            focus: "",
            aiin: [],
            aidifferentiation: undefined,
        },
        pages: 12, search: 2, documenttype: undefined,
        definitions: [],
        sourceinfo: undefined,
    },
    {
        title: "",
        link: "https://static.igem.wiki/teams/4118/wiki/website-assets/collaborations/msp-vector-2022.pdf",
        tag: "",
        author: "",
        textinfo: {
            focus: "",
            aiin: [],
            aidifferentiation: undefined,
        },
        pages: 56,
        search: 2, documenttype: undefined,
        definitions: [],
        sourceinfo: undefined,
    },
    {
        title: "",
        link: "https://static.igem.wiki/teams/5578/image/human-practice/ethics-of-synthetic-biology-in-water-environment-governance.pdf",
        tag: "",
        author: "",
        textinfo: {
            focus: "",
            aiin: [],
            aidifferentiation: undefined,
        },
        pages: undefined, search: 2, documenttype: undefined,
        definitions: [],
        sourceinfo: undefined,
    },
    {
        title: "",
        link: "https://static.igem.wiki/teams/5197/pdfs/business-plan-time2act.pdf",
        tag: "",
        author: "",
        textinfo: {
            focus: "",
            aiin: [],
            aidifferentiation: undefined,
        },
        pages: undefined, search: 2, documenttype: undefined,
        definitions: [],
        sourceinfo: undefined,
    },
    {
        title: "",
        link: "https://static.igem.wiki/teams/5541/hp/edu/synthetic-biology-communication-handbook.pdf",
        tag: "",
        author: "",
        textinfo: {
            focus: "",
            aiin: [],
            aidifferentiation: undefined,
        },
        pages: undefined, search: 2, documenttype: undefined,
        definitions: [],
        sourceinfo: undefined,
    },
    {
        title: "",
        link: "https://static.igem.wiki/teams/5197/pdfs/cnn-1-0-notes-en.pdf",
        tag: "",
        author: "",
        textinfo: {
            focus: "",
            aiin: [],
            aidifferentiation: undefined,
        },
        pages: 31, search: 2, documenttype: undefined,
        definitions: [],
        sourceinfo: undefined,
    },
    {
        title: "",
        link: "https://static.igem.wiki/teams/5197/pdfs/results-dry-lab-geneius.pdf",
        tag: "",
        author: "",
        textinfo: {
            focus: "",
            aiin: [],
            aidifferentiation: undefined,
        },
        pages: undefined, search: 2, documenttype: undefined,
        definitions: [],
        sourceinfo: undefined,
    },
    {
        title: "",
        link: "https://static.igem.wiki/teams/4826/wiki/model-methods.pdf",
        tag: "",
        author: "",
        textinfo: {
            focus: "",
            aiin: [],
            aidifferentiation: undefined,
        },
        pages: undefined, search: 2, documenttype: undefined,
        definitions: [],
        sourceinfo: undefined,
    },
    {
        title: "",
        link: "https://static.igem.wiki/teams/5183/hub/proofconceptpage/proof.pdf",
        tag: "",
        author: "",
        textinfo: {
            focus: "",
            aiin: [],
            aidifferentiation: undefined,
        },
        pages: undefined, search: 2, documenttype: undefined,
        definitions: [],
        sourceinfo: undefined,
    },
    {
        title: "",
        link: "https://static.igem.wiki/teams/4287/wiki/project/handbook-en.pdf",
        tag: "",
        author: "",
        textinfo: {
            focus: "",
            aiin: [],
            aidifferentiation: undefined,
        },
        pages: undefined, search: 2, documenttype: undefined,
        definitions: [],
        sourceinfo: undefined,
    },
    {
        title: "",
        link: "https://static.igem.wiki/teams/4639/wiki/project-hyperion-1.pdf",
        tag: "",
        author: "",
        textinfo: {
            focus: "",
            aiin: [],
            aidifferentiation: undefined,
        },
        pages: undefined, search: 2, documenttype: undefined,
        definitions: [],
        sourceinfo: undefined,
    },
    {
        title: "",
        link: "https://static.igem.wiki/teams/5461/copd-risk-1.pdf",
        tag: "",
        author: "",
        textinfo: {
            focus: "",
            aiin: [],
            aidifferentiation: undefined,
        },
        pages: 9, search: 3, documenttype: undefined,
        definitions: [],
        sourceinfo: undefined,
    },
    {
        title: "",
        link: "https://static.igem.wiki/teams/5928/photo/education/2025-nthu-summer-internship-program/wl-results/case-study/case-study-lin-yanping.pdf",
        tag: "",
        author: "",
        textinfo: {
            focus: "",
            aiin: [],
            aidifferentiation: undefined,
        },
        pages: 2, search: 3, documenttype: undefined,
        definitions: [],
        sourceinfo: undefined,
    },
    {
        title: "",
        link: "https://static.igem.wiki/teams/4943/wiki/model.pdf",
        tag: "",
        author: "",
        textinfo: {
            focus: "",
            aiin: [],
            aidifferentiation: undefined,
        },
        pages: 17, search: 3, documenttype: undefined,
        definitions: [],
        sourceinfo: undefined,
    },
    {
        title: "",
        link: "https://static.igem.wiki/teams/5182/project/engi/drylabengcyc.pdf",
        tag: "",
        author: "",
        textinfo: {
            focus: "",
            aiin: [],
            aidifferentiation: undefined,
        },
        pages: 10, search: 3, documenttype: undefined,
        definitions: [],
        sourceinfo: undefined,
    },
    {
        title: "",
        link: "https://static.igem.wiki/teams/5102/hp/hp-stir-munich2024-final.pdf",
        tag: "",
        author: "",
        textinfo: {
            focus: "",
            aiin: [],
            aidifferentiation: undefined,
        },
        pages: undefined, search: 3, documenttype: undefined,
        definitions: [],
        sourceinfo: undefined,
        // "Machine learning is not AI"
    },
    {
        title: "",
        link: "https://static.igem.wiki/teams/5789/model-new/deeprpi-user-manual.pdf",
        tag: "",
        author: "",
        textinfo: {
            focus: "",
            aiin: [],
            aidifferentiation: undefined,
        },
        pages: 12, search: 4, documenttype: undefined,
        definitions: [],
        sourceinfo: undefined,
    },
    {
        title: "",
        link: "https://static.igem.wiki/teams/5922/human-practices/deep-learning-modeling.pdf",
        tag: "",
        author: "",
        textinfo: {
            focus: "",
            aiin: [],
            aidifferentiation: undefined,
        },
        pages: 9, search: 4, documenttype: undefined,
        definitions: [],
        sourceinfo: undefined,
    },
    {
        title: "",
        link: "https://static.igem.wiki/teams/4267/wiki/notebook/hard.pdf",
        tag: "",
        author: "",
        textinfo: {
            focus: "",
            aiin: [],
            aidifferentiation: undefined,
        },
        pages: 94, search: 4, documenttype: undefined,
        definitions: [],
        sourceinfo: undefined,
    },
    {
        title: "",
        link: "https://static.igem.wiki/teams/4113/wiki/wiki-image/pdf/model-final.pdf",
        tag: "",
        author: "",
        textinfo: {
            focus: "",
            aiin: [],
            aidifferentiation: undefined,
        },
        pages: undefined, search: 4, documenttype: undefined,
        definitions: [],
        sourceinfo: undefined,
    },
    {
        title: "",
        link: "https://static.igem.wiki/teams/5872/hp/hpedu/igem-navigator2.pdf",
        tag: "",
        author: "",
        textinfo: {
            focus: "",
            aiin: [],
            aidifferentiation: undefined,
        },
        pages: undefined, search: 5, documenttype: undefined,
        definitions: [],
        sourceinfo: undefined,
    },
    {
        title: "",
        link: "https://static.igem.wiki/teams/5607/supplementary/llm-introduction.pdf",
        tag: "",
        author: "",
        textinfo: {
            focus: "",
            aiin: [],
            aidifferentiation: undefined,
        },
        pages: undefined, search: 5, documenttype: undefined,
        definitions: [],
        sourceinfo: undefined,
    },
    {
        title: "",
        link: "https://static.igem.wiki/teams/5984/pdf/operation-instructions-and-requirements.pdf",
        tag: "",
        author: "",
        textinfo: {
            focus: "",
            aiin: [],
            aidifferentiation: undefined,
        },
        pages: undefined, search: 5, documenttype: undefined,
        definitions: [],
        sourceinfo: undefined,
    },
    {
        title: "",
        link: "https://static.igem.wiki/teams/5230/entrepreneurship/onepagerplasmidai.pdf",
        tag: "",
        author: "",
        textinfo: {
            focus: "",
            aiin: [],
            aidifferentiation: undefined,
        },
        pages: undefined, search: 5, documenttype: undefined,
        definitions: [],
        sourceinfo: undefined,
    },
    {
        title: "",
        link: "https://static.igem.wiki/teams/5366/communication/back-finale.pdf",
        tag: "",
        author: "",
        textinfo: {
            focus: "",
            aiin: [],
            aidifferentiation: undefined,
        },
        pages: undefined, search: 5, documenttype: undefined,
        definitions: [],
        sourceinfo: undefined,
    },
    {
        title: "",
        link: "https://static.igem.wiki/teams/5673/pdf/igem-pr-sentation-schule-elg-komprimiert.pdf",
        tag: "",
        author: "",
        textinfo: {
            focus: "",
            aiin: [],
            aidifferentiation: undefined,
        },
        pages: undefined, search: 6, documenttype: undefined,
        definitions: [],
        sourceinfo: undefined,
    },
    {
        title: "",
        link: "https://static.igem.wiki/teams/5492/pruritus-final.pdf",
        tag: "",
        author: "",
        textinfo: {
            focus: "",
            aiin: [],
            aidifferentiation: undefined,
        },
        pages: undefined, search: 6, documenttype: undefined,
        definitions: [],
        sourceinfo: undefined,
    },
    {
        title: "",
        link: "https://static.igem.wiki/teams/5934/outreach/dry-lab-model.pdf",
        tag: "",
        author: "",
        textinfo: {
            focus: "",
            aiin: [],
            aidifferentiation: undefined,
        },
        pages: undefined, search: 6, documenttype: undefined,
        definitions: [],
        sourceinfo: undefined,
    },
    {
        title: "",
        link: "https://2025.igem.wiki/ccu-taiwan/contribution#Our-Solution-A-Custom-AI-Advisor-for-iGEM",
        tag: "",
        author: "",
        textinfo: {
            focus: "",
            aiin: [],
            aidifferentiation: undefined,
        },
        pages: undefined, search: 7, documenttype: undefined,
        definitions: [],
        sourceinfo: undefined,
    },
    {
        title: "",
        link: "https://2024.igem.wiki/xjtlu-software/model.html",
        tag: "",
        author: "",
        textinfo: {
            focus: "",
            aiin: [],
            aidifferentiation: undefined,
        },
        pages: undefined, search: 7, documenttype: undefined,
        definitions: [],
        sourceinfo: undefined,
    },
    {
        title: "",
        link: "https://2024.igem.wiki/hkust-gz/llm",
        tag: "",
        author: "",
        textinfo: {
            focus: "",
            aiin: [],
            aidifferentiation: undefined,
        },
        pages: undefined, search: 7, documenttype: undefined,
        definitions: [],
        sourceinfo: undefined,
    },
    {
        title: "",
        link: "https://2024.igem.wiki/dtu-denmark/software",
        tag: "",
        author: "",
        textinfo: {
            focus: "",
            aiin: [],
            aidifferentiation: undefined,
        },
        pages: undefined, search: 7, documenttype: undefined,
        definitions: [],
        sourceinfo: undefined,
    },
    {
        title: "",
        link: "https://2025.igem.wiki/hkust-gz/software",
        tag: "",
        author: "",
        textinfo: {
            focus: "",
            aiin: [],
            aidifferentiation: undefined,
        },
        pages: undefined, search: 7, documenttype: undefined,
        definitions: [],
        sourceinfo: undefined,
    },
    {
        title: "",
        link: "https://2024.igem.wiki/xjtlu-software/description.html",
        tag: "",
        author: "",
        textinfo: {
            focus: "",
            aiin: [],
            aidifferentiation: undefined,
        },
        pages: undefined, search: 7, documenttype: undefined,
        definitions: [],
        sourceinfo: undefined,
    },
    {
        title: "",
        link: "https://2024.igem.wiki/asu/software",
        tag: "",
        author: "",
        textinfo: {
            focus: "",
            aiin: [],
            aidifferentiation: undefined,
        },
        pages: undefined, search: 7, documenttype: undefined,
        definitions: [],
        sourceinfo: undefined,
    },
    {
        title: "",
        link: "https://2024.igem.wiki/utoronto/description.html",
        tag: "",
        author: "",
        textinfo: {
            focus: "",
            aiin: [],
            aidifferentiation: undefined,
        },
        pages: undefined, search: 7, documenttype: undefined,
        definitions: [],
        sourceinfo: undefined,
    },
    {
        title: "",
        link: "https://2024.igem.wiki/nju-china/llama-3",
        tag: "",
        author: "",
        textinfo: {
            focus: "",
            aiin: [],
            aidifferentiation: undefined,
        },
        pages: undefined, search: 7, documenttype: undefined,
        definitions: [],
        sourceinfo: undefined,
    },
    {
        title: "",
        link: "https://2024.igem.wiki/peking/contribution#",
        tag: "",
        author: "",
        textinfo: {
            focus: "",
            aiin: [],
            aidifferentiation: undefined,
        },
        pages: undefined, search: 7, documenttype: undefined,
        definitions: [],
        sourceinfo: undefined,
    },
    {
        title: "",
        link: "https://2025.igem.wiki/fudan/human-practices.html",
        tag: "",
        author: "",
        textinfo: {
            focus: "",
            aiin: [],
            aidifferentiation: undefined,
        },
        pages: undefined, search: 8, documenttype: undefined,
        definitions: [],
        sourceinfo: undefined,
    },
    {
        title: "",
        link: "https://2024.igem.wiki/xjtlu-software/",
        tag: "",
        author: "",
        textinfo: {
            focus: "",
            aiin: [],
            aidifferentiation: undefined,
        },
        pages: undefined, search: 8, documenttype: undefined,
        definitions: [],
        sourceinfo: undefined,
    },
    {
        title: "",
        link: "https://2025.igem.wiki/peking/human-practices/",
        tag: "",
        author: "",
        textinfo: {
            focus: "",
            aiin: [],
            aidifferentiation: undefined,
        },
        pages: undefined, search: 8, documenttype: undefined,
        definitions: [],
        sourceinfo: undefined,
    },
    {
        title: "",
        link: "https://2023.igem.wiki/nju-china/human-practices",
        tag: "",
        author: "",
        textinfo: {
            focus: "",
            aiin: [],
            aidifferentiation: undefined,
        },
        pages: undefined, search: 8, documenttype: undefined,
        definitions: [],
        sourceinfo: undefined,
    },
    {
        title: "",
        link: "https://2025.igem.wiki/cjuh-jlu-china/human-practices#ihp-overview",
        tag: "",
        author: "",
        textinfo: {
            focus: "",
            aiin: [],
            aidifferentiation: undefined,
        },
        pages: undefined, search: 8, documenttype: undefined,
        definitions: [],
        sourceinfo: undefined,
    },
    {
        title: "",
        link: "https://2025.igem.wiki/jilin-ai/human-practices",
        tag: "",
        author: "",
        textinfo: {
            focus: "",
            aiin: [],
            aidifferentiation: undefined,
        },
        pages: undefined, search: 8, documenttype: undefined,
        definitions: [],
        sourceinfo: undefined,
    },
    {
        title: "",
        link: "https://2024.igem.wiki/utoronto/human-practices.html",
        tag: "",
        author: "",
        textinfo: {
            focus: "",
            aiin: [],
            aidifferentiation: undefined,
        },
        pages: undefined, search: 8, documenttype: undefined,
        definitions: [],
        sourceinfo: undefined,
    },
    {
        title: "",
        link: "https://2024.igem.wiki/ustc-software/human-practices",
        tag: "",
        author: "",
        textinfo: {
            focus: "",
            aiin: [],
            aidifferentiation: undefined,
        },
        pages: undefined, search: 8, documenttype: undefined,
        definitions: [],
        sourceinfo: undefined,
    },
    {
        title: "",
        link: "https://2025.igem.wiki/jilin-ai/members",
        tag: "",
        author: "",
        textinfo: {
            focus: "",
            aiin: [],
            aidifferentiation: undefined,
        },
        pages: undefined, search: 9, documenttype: undefined,
        definitions: [],
        sourceinfo: undefined,
    },
    {
        title: "",
        link: "https://2024.igem.wiki/sjtu-software/ai",
        tag: "",
        author: "",
        textinfo: {
            focus: "",
            aiin: [],
            aidifferentiation: undefined,
        },
        pages: undefined, search: 9, documenttype: undefined,
        definitions: [],
        sourceinfo: undefined,
    },
    {
        title: "",
        link: "https://2024.igem.wiki/evry-paris-saclay/",
        tag: "",
        author: "",
        textinfo: {
            focus: "",
            aiin: [],
            aidifferentiation: undefined,
        },
        pages: undefined, search: 9, documenttype: undefined,
        definitions: [],
        sourceinfo: undefined,
    },
    {
        title: "",
        link: "https://2023.igem.wiki/nju-china/model",
        tag: "",
        author: "",
        textinfo: {
            focus: "",
            aiin: [],
            aidifferentiation: undefined,
        },
        pages: undefined, search: 9, documenttype: undefined,
        definitions: [],
        sourceinfo: undefined,
    },
    {
        title: "",
        link: "https://2025.igem.wiki/jilin-ai/description",
        tag: "",
        author: "",
        textinfo: {
            focus: "",
            aiin: [],
            aidifferentiation: undefined,
        },
        pages: undefined, search: 9, documenttype: undefined,
        definitions: [],
        sourceinfo: undefined,
    },
    {
        title: "",
        link: "https://2024.igem.wiki/nanjing-china/ai-model",
        tag: "",
        author: "",
        textinfo: {
            focus: "",
            aiin: [],
            aidifferentiation: undefined,
        },
        pages: undefined, search: 9, documenttype: undefined,
        definitions: [],
        sourceinfo: undefined,
    },
    {
        title: "",
        link: "https://2023.igem.wiki/nju-china/description",
        tag: "",
        author: "",
        textinfo: {
            focus: "",
            aiin: [],
            aidifferentiation: undefined,
        },
        pages: undefined, search: 9, documenttype: undefined,
        definitions: [],
        sourceinfo: undefined,
    },
    {
        title: "",
        link: "https://2025.igem.wiki/jilin-ai/",
        tag: "",
        author: "",
        textinfo: {
            focus: "",
            aiin: [],
            aidifferentiation: undefined,
        },
        pages: undefined, search: 9, documenttype: undefined,
        definitions: [],
        sourceinfo: undefined,
    },
    {
        title: "",
        link: "https://2025.igem.wiki/toronto/contribution/",
        tag: "",
        author: "",
        textinfo: {
            focus: "",
            aiin: [],
            aidifferentiation: undefined,
        },
        pages: undefined, search: 10, documenttype: undefined,
        definitions: [],
        sourceinfo: undefined,
    },
    {
        title: "",
        link: "https://2024.igem.wiki/iea/model",
        tag: "",
        author: "",
        textinfo: {
            focus: "",
            aiin: [],
            aidifferentiation: undefined,
        },
        pages: undefined, search: 10, documenttype: undefined,
        definitions: [],
        sourceinfo: undefined,
    },
    {
        title: "",
        link: "https://2024.igem.wiki/utoronto/model",
        tag: "",
        author: "",
        textinfo: {
            focus: "",
            aiin: [],
            aidifferentiation: undefined,
        },
        pages: undefined, search: 10, documenttype: undefined,
        definitions: [],
        sourceinfo: undefined,
    },
    {
        title: "",
        link: "https://2025.igem.wiki/toronto/model/",
        tag: "",
        author: "",
        textinfo: {
            focus: "",
            aiin: [],
            aidifferentiation: undefined,
        },
        pages: undefined, search: 10, documenttype: undefined,
        definitions: [],
        sourceinfo: undefined,
    },
    {
        title: "",
        link: "https://2025.igem.wiki/dut-china/5%27utr_sequence",
        tag: "",
        author: "",
        textinfo: {
            focus: "",
            aiin: [],
            aidifferentiation: undefined,
        },
        pages: undefined, search: 10, documenttype: undefined,
        definitions: [],
        sourceinfo: undefined,
    },
    {
        title: "",
        link: "https://2025.igem.wiki/iit-roorkee/results",
        tag: "",
        author: "",
        textinfo: {
            focus: "",
            aiin: [],
            aidifferentiation: undefined,
        },
        pages: undefined, search: 10, documenttype: undefined,
        definitions: [],
        sourceinfo: undefined,
    },
    {
        title: "",
        link: "https://2025.igem.wiki/hpi-potsdam/software/biocomplete-editor",
        tag: "",
        author: "",
        textinfo: {
            focus: "",
            aiin: [],
            aidifferentiation: undefined,
        },
        pages: undefined, search: 11, documenttype: undefined,
        definitions: [],
        sourceinfo: undefined,
    },
    {
        title: "",
        link: "https://2025.igem.wiki/jilin-ai/overview",
        tag: "",
        author: "",
        textinfo: {
            focus: "",
            aiin: [],
            aidifferentiation: undefined,
        },
        pages: undefined, search: 11, documenttype: undefined,
        definitions: [],
        sourceinfo: undefined,
    },
    {
        title: "",
        link: "https://2025.igem.wiki/jilin-ai/engineering",
        tag: "",
        author: "",
        textinfo: {
            focus: "",
            aiin: [],
            aidifferentiation: undefined,
        },
        pages: undefined, search: 11, documenttype: undefined,
        definitions: [],
        sourceinfo: undefined,
    },
    {
        title: "",
        link: "https://2025.igem.wiki/ouc-haide/engineering",
        tag: "",
        author: "",
        textinfo: {
            focus: "",
            aiin: [],
            aidifferentiation: undefined,
        },
        pages: undefined, search: 12, documenttype: undefined,
        definitions: [],
        sourceinfo: undefined,
    },
    {
        title: "",
        link: "https://2024.igem.wiki/xjtlu-software/software.html",
        tag: "",
        author: "",
        textinfo: {
            focus: "",
            aiin: [],
            aidifferentiation: undefined,
        },
        pages: undefined, search: 13, documenttype: undefined,
        definitions: [],
        sourceinfo: undefined,
    },
    {
        title: "",
        link: "https://2025.igem.wiki/bwya/model",
        tag: "",
        author: "",
        textinfo: {
            focus: "",
            aiin: [],
            aidifferentiation: undefined,
        },
        pages: undefined, search: 13, documenttype: undefined,
        definitions: [],
        sourceinfo: undefined,
    },
    {
        title: "",
        link: "https://2025.igem.wiki/bnu-china/human-practices",
        tag: "",
        author: "",
        textinfo: {
            focus: "",
            aiin: [],
            aidifferentiation: undefined,
        },
        pages: undefined, search: 13, documenttype: undefined,
        definitions: [],
        sourceinfo: undefined,
    },
    {
        title: "",
        link: "https://2024.igem.wiki/xjtlu-software/engineering",
        tag: "",
        author: "",
        textinfo: {
            focus: "",
            aiin: [],
            aidifferentiation: undefined,
        },
        pages: undefined, search: 13, documenttype: undefined,
        definitions: [],
        sourceinfo: undefined,
    },
    {
        title: "",
        link: "https://2025.igem.wiki/jilin-ai/safety-and-security",
        tag: "",
        author: "",
        textinfo: {
            focus: "",
            aiin: [],
            aidifferentiation: undefined,
        },
        pages: undefined, search: 14, documenttype: undefined,
        definitions: [],
        sourceinfo: undefined,
    },
    {
        title: "",
        link: "https://2024.igem.wiki/lcg-china/ai-safety-policy",
        tag: "",
        author: "",
        textinfo: {
            focus: "",
            aiin: [],
            aidifferentiation: undefined,
        },
        pages: undefined, search: 14, documenttype: undefined,
        definitions: [],
        sourceinfo: undefined,
    },
    {
        title: "",
        link: "https://2024.igem.wiki/lcg-china/safety",
        tag: "",
        author: "",
        textinfo: {
            focus: "",
            aiin: [],
            aidifferentiation: undefined,
        },
        pages: undefined, search: 14, documenttype: undefined,
        definitions: [],
        sourceinfo: undefined,
    },

]

// TODO noch suchen:
// ai use site:https://igem.wiki

// https://static.igem.wiki/teams/5916/education/public/imperial-igem-biophilosophy.pdf
// https://static.igem.wiki/teams/5821/ihp/10-government-interview.pdf
// ml https://static.igem.wiki/teams/4237/wiki/human-practices/13-once-bp-english-version.pdf

/*
 {
        title: "",
        link: "",
        tag: "",
        author: ""
    }

     {
        title: "",
        link: "",
        tag: "",
        author: "",
        textinfo: {
            focus: "",
            aiin: [],
            aidifferentiation: undefined,
        },
        pages: undefined, search: 14, documenttype: undefined,
        definitions: [],
        sourceinfo: undefined,
    }
 */

// TODO bsp schlecht lesbar https://2025.igem.wiki/aboa/human-practices